import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const AdditionalAgentSettings = { id: 10, name: 'Additional Agent Settings' };
export const additionalAgentContext = defineFeature({
    type: FeatureType.Markdown,
    propName: 'additional_agent_context',
    uiName: 'additionalAgentContext',
    displayName: 'Additional Agent Context',
    description: 'Any additional context for the agent',
    category: AdditionalAgentSettings,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const agentDisclaimer = defineFeature({
    type: FeatureType.Markdown,
    propName: 'agent_disclaimer',
    uiName: 'agentDisclaimer',
    displayName: 'Agent Disclaimer',
    description: 'Markdown disclaimer appended to successful agent responses',
    category: AdditionalAgentSettings,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const additionalAgentSettingsFeatures = [additionalAgentContext, agentDisclaimer];
